<template>
  <div class="users-create" v-loading="loader">
    <el-form>
      <el-form-item label="ФИО">
        <el-input v-model="form.name" placeholder=""/>
      </el-form-item>
      <el-form-item label="Табельный номер">
        <el-input v-model="form.personnelNumber" placeholder=""/>
      </el-form-item>
      <el-form-item label="Часовая ставка">
        <el-input v-model="form.hourRate" placeholder=""/>
      </el-form-item>

      <filter-select
        v-model="form.profId"
        label="Профессия"
        onlyValue
        :options="options.profs"
      />

      <el-form-item label="Примечание">
        <el-input v-model="form.comment" placeholder=""/>
      </el-form-item>

      <div v-if="$route.params.userId" style="display: flex; justify-content: space-between">
        <el-button v-if="$route.params.userId" type="danger"
                   @click="deleteObject">Удалить
        </el-button>
        <el-button type="primary" @click="save">Редактировать</el-button>

      </div>
      <div v-else>
        <el-button type="primary" @click="save" style="width: 100%">Сохранить</el-button>

      </div>
    </el-form>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import FilterSelect from '../../../../components/FilterSelect';
import TabelProxy from "../../../../proxy/TabelProxy";
import firebase from "firebase";


export default {
  name: 'UsersCreateCompany',
  components: {FilterSelect, draggable},
  props: ['company'],
  data() {
    return {
      loader: false,
      options: {
        profs: []
      },
      form: {
        name: "",
        personnelNumber: "",
        profId: "",
        comment: "",
        hourRate: ""
      }
    };
  },
  async mounted() {
    this.fetchProfs()
    const proxy = new TabelProxy();

    if (this.$route.params.userId) {
      const response = await proxy.getUser(this.$route.params.userId)

      const {name, personnelNumber, profId, comment, hourRate, _id} = response.data

      this.form = {
        name,
        personnelNumber,
        profId,
        comment,
        hourRate,
        employeeId: _id
      }
    }
  },

  methods: {
    setName(name) {
      this.form.name = name
    },
    async save() {
      this.loader = true
      const proxy = new TabelProxy();
      if (!this.$route.params.userId) {
        const response = await proxy.create(this.$store.state.project.id, {
          ...this.form,
          companyId: this.company || this.$route.params.id
        })


        if (response.status === 'error') {
          this.$notify({
            offset: 60,
            title: 'Ошибка',
            message: 'Заполните все поля',
            type: 'error',
          });
        } else {
          if(!this.company) {
            this.$notify({
              offset: 60,
              title: 'Успешно!',
              message: 'Новый работник добавлен',
              type: 'success',
            });

            this.$router.go(-1);
          } else {
            this.$emit('addNewUser', response.data._id)
          }
        }
      } else {
        const response = await proxy.update({
          ...this.form,
          companyId: this.company || this.$route.params.id,
          projectId: this.$store.state.project.id
        })

        if (response.status === 'error') {
          this.$notify({
            offset: 60,
            title: 'Ошибка',
            message: 'Заполните все поля',
            type: 'error',
          });
        } else {

          this.$notify({
            offset: 60,
            title: 'Успешно!',
            message: 'Отредактировано',
            type: 'success',
          });

          this.$router.go(-1);
        }
      }
      this.loader = false

    },
    deleteObject() {
      this.$confirm('Вы действительно хотите удалить?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(async () => {


        const proxy = new TabelProxy();

        proxy.remove(this.$route.params.userId)
        this.$notify({
          offset: 60,
          title: 'Успешно!',
          message: 'удалено',
          type: 'success',
        });
        this.$router.go(-1);
      });
    },
    async fetchProfs() {
      const responseProf = await myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('jobs')
        .where('type', '==', 'PROF').get();

      const result = []
      responseProf.forEach((data) => {
        result.push({
          label: data.data().name,
          value: data.id
        })
      })

      this.options.profs = result;
    },
    getUrl() {
      return ``
    }
  },

  computed: {
    filteredList() {
      return this.jobs.filter((job) => {
        return job.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
};
</script>

<style scoped lang="scss">
.users-create {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 42px auto;
  padding-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Users/company/UsersCreate.vue